module.exports = __webpack_public_path__ + "static/media/0cc1e52d.jpg";